module.exports = __webpack_public_path__ + "img/horizontal_4_1_7016.e14eecbb.png";